export const DefaultBillingAddressIsSameAsLicensee = true;
export const CheckoutStepId = {
  project: 'project-details',
  license: 'license-information',
  billing: 'billing-information',
  review: 'review',
  orderPlaced: 'order-placed',
};

export const CheckoutStepFormName = {
  project: 'checkout-project-details',
  license: 'checkout-license-information',
  billing: 'checkout-billing-information',
  review: 'checkout-review',
};

export const CheckoutStepsOrder = {
  [CheckoutStepId.project]: 1,
  [CheckoutStepId.license]: 2,
  [CheckoutStepId.billing]: 3,
  [CheckoutStepId.review]: 4,
};

export const CompanyTypes = [
  { value: 1001, label: 'Ad Agency' },
  { value: 1002, label: 'Production' },
  { value: 1003, label: 'Editorial House' },
  { value: 1004, label: 'Music House' },
  { value: 1005, label: 'Broadcaster' },
  { value: 1006, label: 'Other' },
];

export const RepresentativeRoles = [
  { value: 1001, label: 'Producer' },
  { value: 1002, label: 'Copywriter' },
  { value: 1003, label: 'Creative Director' },
  { value: 1004, label: 'Editor' },
  { value: 1005, label: 'Art Director' },
  { value: 1006, label: 'Music Supervisor' },
  { value: 1007, label: 'Other' },
];

export const kCheckoutNoInputLabel = '<not specified>';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/config.ts